/* global debounce */
if (!customElements.get('cart-attribute')) {
  class CartAttribute extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('[data-cart-attribute-input]');
      this.attributeName = this.input ? this.input.dataset.cartAttributeInput : null;

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      if (!this.input || !this.attributeName) return;

      this.debouncedHandleAttributeChange = debounce(this.handleAttributeChange.bind(this), 300);
      this.input.addEventListener('input', this.debouncedHandleAttributeChange);
      this.input.addEventListener('change', this.debouncedHandleAttributeChange);
    }

    handleAttributeChange(evt) {
      this.fetchRequestOpts.body = JSON.stringify({
        attributes: {
          [this.attributeName]: evt.target.value
        }
      });

      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-attribute', CartAttribute);
}
